import React, { useMemo, useState, useImperativeHandle } from "react";
import { Menu, message, Tooltip } from "@cloud/atom-ui";

import history from "@src/utils/history";
import "./style.css";
import * as css from "./style.m.css";
import LeftOutlined from "@cloud/atom-ui-icons/LeftOutlined";
import subMenuConfig from "../../config/config";
import useMappedState from "@src/utils/useMappedState";
import i18n from "@src/i18n";
import classnames from "classnames";
import { queryString } from "@src/utils/common";
import { Link } from "react-router-dom";
import { routerConfig } from "../../config/router-list";
import { abilityType } from "../../utils/utils";
import { Layout } from "@cloud/atom-ui";
import {urlDomainDeal} from "@src/utils/common";

const { Sider } = Layout;

export default React.forwardRef((props, ref) => {
  const { searchFlag, appInfo } = useMappedState("root");
  const type = useMemo(() => {
    const typeParam = queryString("type");
    if (typeParam) {
      return typeParam;
    } else {
      return window.location.hash?.split("#")?.[1]?.split("/")?.[1];
    }
  }, []);
  let selectedKey =
    "/" +
    location?.hash
      ?.split("?")?.[0]
      ?.split("/")
      ?.pop();

  const [menuConfig, setMenuConfig] = useState(subMenuConfig);
  const menus = useMemo(() => {
    return menuConfig;
  }, []);

  useImperativeHandle(ref, () => ({
    setMenuConfig
  }));

  const clickBack = () => {
    const edit = queryString("edit");
    if (edit === "1") {
      message.error("请先保存编辑内容！");
    } else {
      // 查询之后进入
      if (searchFlag) {
        history.push("/search");
      } else {
        history.push(`/${type}/wecode-v2`);
      }
    }
  };

  const RenderMenu = menu => {
    if (menu.children && menu.children.length) {
      // 追加 “0” 防止与子菜单 key 冲突
      return (
        <div key={menu.key}>
          <p className={css["menu-name"]}>{menu.menuName}</p>
          {menu.children.map((menu, index) => {
            return RenderMenu(menu, index);
          })}
          <div className={css["menu_section_line"]}></div>
        </div>
      );
    }

    const weRouter = menu.key === routerConfig.applicationWe;
    const lightRouter = menu.key === routerConfig.applicationLight;
    const RobotRouter = menu.key === routerConfig.applicationRobot;
    const weHidden =
      weRouter && !appInfo?.abilityList?.includes(abilityType.wecode);
    const lightHidden =
      lightRouter && !appInfo?.abilityList?.includes(abilityType.h5);
    const RobotHidden = RobotRouter && !appInfo?.abilityList?.includes(abilityType.robot);
    if (menu.isHide) {
      if (!weRouter && !lightRouter && !RobotRouter) {
        return null;
      } else if (weHidden || lightHidden || RobotHidden) {
        return null;
      }
    }
    return (
      <Menu.Item
        className={css["edit_detail_menu_item"]}
        key={menu.key}
        style={{
          backgroundColor: selectedKey === menu.resUrl ? "#E0EFFF" : ""
        }}
        icon={
          <img
            className={classnames(css["left_menu_icon"], {
              [css["left_menu_icon_select"]]: selectedKey === menu.resUrl
            })}
            src={menu.icon}
          />
        }
      >
        <div
          style={{ overflow: "hidden", textOverflow: "ellipsis" }}
          className={
            selectedKey === menu.resUrl
              ? css["menu_title_activity"]
              : css["menu_title"]
          }
        >
          <Link
            to={`/${type}/appdetailV2${menu.resUrl}?id=${appInfo?.aliasName}&type=${type}`}
          >
            {menu.menuName}
          </Link>
        </div>
      </Menu.Item>
    );
  };

  const renderBack = () => {
    return (
      <div className={css["left-slider-back"]}>
        <div className={css["back-img-div"]} onClick={clickBack}>
          <LeftOutlined className={css["back-img"]} />
        </div>
        <img className={css["avatar"]} src={urlDomainDeal(appInfo?.icon?.showUrl)}></img>
        <Tooltip title={i18n.getLoc(appInfo?.nameEn, appInfo?.nameCn)}>
          <p className={css["app-name"]} style={{ WebkitBoxOrient: "vertical" }}>
            {i18n.getLoc(appInfo?.nameEn, appInfo?.nameCn)}
          </p>
        </Tooltip>
      </div>
    );
  };

  return (
    <Sider
      collapsible={false}
      width={200}
      style={{
        background: "#fff"
      }}
    >
      <div className={css["edit-detail-left-slider"]}>
        {renderBack()}
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={selectedKey}
          style={{ height: "100%", width: "100%", marginTop: 0 }}
          className={"editDetailLeft"}
        >
          {menuConfig.map((menu, index) => {
            return RenderMenu(menu, index);
          })}
        </Menu>
        <div style={{ marginBottom: "30px" }}></div>
      </div>
    </Sider>
  );
});
